import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
const rooms = [
  {
    name: "Doppelzimmer",
    count: "18 Zimmer gesamt",
    description: "Das Doppelzimmer ist die zentrale Zimmerkategorie von Hiru Villa und verbindet kolonialen Charme mit zeitgem\xE4\xDFem Komfort. Mit viel Platz, eigener Terrasse oder Balkon und dem Blick auf das Meer genie\xDFen Sie entspannte Momente in ruhiger Atmosph\xE4re.",
    features: ["Ger\xE4umiger Raum von ca. 32 m\xB2", "Eigener Balkon oder Terrasse", "Klimaanlage, Deckenventilator und Moskitonetz", "Dusche und kostenloses WLAN"],
    images: [
      "/images/Hiru/Hiru Villa's/Room/AH2I3011-Edit-copy.webp",
      "/images/Hiru/Hiru Villa's/Room/AH2I3028-Edit-copy.webp",
      "/images/Hiru/Hiru Villa's/Room/AH2I3164-Edit-copy.webp",
      "/images/Hiru/Hiru Villa's/Room/AH2I3423-HDR-Edit-copy.webp"
    ]
  },
  {
    name: "Junior Suite",
    count: "1 Zimmer",
    description: "F\xFCr G\xE4ste, die mehr Platz und Ruhe genie\xDFen m\xF6chten, ist die Junior Suite besonders komfortabel und stilvoll. Die offene, lichtdurchflutete Einrichtung l\xE4sst die Spannung von K\xF6rper und Geist langsam abfallen.",
    features: ["Ger\xE4umiger privater Wohnbereich", "Eigene Terrasse mit Meerblick", "Gem\xFCtlicher Schlafbereich", "Voll ausgestattete Ausstattung f\xFCr einen angenehmen Aufenthalt"],
    images: [
      "/images/Hiru/Hiru Villa's/Junior Suite/680A1902-Edit-copy.webp",
      "/images/Hiru/Hiru Villa's/Junior Suite/680A1926-Edit-copy.webp",
      "/images/Hiru/Hiru Villa's/Junior Suite/680A1959-Edit-cop-T.webp",
      "/images/Hiru/Hiru Villa's/Junior Suite/680A2015-copy.webp"
    ]
  },
  {
    name: "Master Suite",
    count: "1 Zimmer",
    description: "Die Master Suite ist das luxuri\xF6seste Zimmer von Hiru Villa und bietet Ihnen eine besondere Auszeit vom Alltag. Mit hochwertiger Einrichtung, viel Raum und ruhiger Atmosph\xE4re erwartet Sie echte Erholung.",
    features: ["Besonders elegantes Zimmer im Herzen von Hiru Villa", "Ger\xE4umiges Wohnzimmer und Schlafzimmer", "Terrasse mit wundersch\xF6nem Ausblick", "Durchdachte Gestaltung f\xFCr Ruhe und Privatsph\xE4re"],
    images: [
      "/images/Hiru/Hiru Villa's/Master Suite/680A2236-Edit-copy.webp",
      "/images/Hiru/Hiru Villa's/Master Suite/680A2102-Edit-Open Curtain.webp",
      "/images/Hiru/Hiru Villa's/Master Suite/680A2418-HDR-Edit-copy.webp",
      "/images/Hiru/Hiru Villa's/Master Suite/680A2348-Edit-copy.webp"
    ]
  }
];
const VillaRooms = () => {
  const [activeGallery, setActiveGallery] = useState(null);
  const activeRoom = activeGallery === null ? null : rooms[activeGallery];
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <p className="font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
          Zimmer in Hiru Villa
        </p>
        <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
          Drei Zimmerkategorien für ruhige Tage
        </h2>
        <p className="mt-5 font-mulish text-base leading-8 text-gray-600 sm:text-lg">
          Wir bieten Zimmer mit individuellem Charakter und passend zu Ihrem Reisegefühl an.
        </p>
      </div>

      <div className="mx-auto mt-12 grid max-w-7xl gap-7 lg:grid-cols-3 lg:gap-8">
        {rooms.map((room, roomIndex) => <article
          key={room.name}
          className="group overflow-hidden rounded-[26px] bg-[#fbfaf7] shadow-[0_22px_65px_rgba(16,38,26,0.1)]"
        >
          <button
            type="button"
            className="relative block aspect-[4/3] w-full overflow-hidden bg-[#f3eee7] text-left"
            onClick={() => setActiveGallery(roomIndex)}
            aria-label={`Bilder von ${room.name} ansehen`}
          >
            <img
              src={room.images[0]}
              alt={`Zimmer ${room.name}`}
              className="object-cover transition-transform duration-700 group-hover:scale-[1.04]" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#07130d]/75 via-transparent to-transparent" />
            <div className="absolute inset-x-5 bottom-5 flex items-end justify-between gap-3 text-white">
              <div>
                <p className="font-mulish text-xs font-semibold uppercase tracking-[0.22em] text-amber-200">
                  {room.count}
                </p>
                <h3 className="mt-2 font-serif text-2xl font-semibold sm:text-3xl">{room.name}</h3>
              </div>
              <span className="rounded-full bg-white/20 px-3 py-2 text-xs font-semibold backdrop-blur-md">
                Bilder ansehen
              </span>
            </div>
          </button>

          <div className="p-6 sm:p-7">
            <p className="font-mulish text-[15px] leading-8 text-gray-700 sm:text-base">
              {room.description}
            </p>
            <ul className="mt-5 space-y-2 border-l-2 border-amber-300 pl-4 font-mulish text-sm leading-7 text-[#475569]">
              {room.features.map((feature) => <li key={feature}>{feature}</li>)}
            </ul>
            <button
              type="button"
              onClick={() => setActiveGallery(roomIndex)}
              className="mt-6 inline-flex items-center rounded-full bg-[#F28600] px-5 py-3 font-mulish text-sm font-semibold text-white shadow-lg shadow-[#f28600]/20 transition hover:bg-[#d67000]"
            >
              Zimmerbilder ansehen
            </button>
          </div>
        </article>)}
      </div>
    </div>

    {activeRoom ? <Lightbox
      open={activeGallery !== null}
      close={() => setActiveGallery(null)}
      slides={activeRoom.images.map((image) => ({ src: image }))}
      plugins={[Thumbnails, Zoom]}
      thumbnails={{ position: "bottom", border: 0, vignette: true }}
      zoom={{ maxZoomPixelRatio: 3 }}
      carousel={{ finite: false }}
    /> : null}
  </section>;
};
export default VillaRooms;
